import { CircularProgress } from "@mui/material";
import React from "react";

import "./CustomPageLoader.scss";
import classNames from "classnames";

const CustomPageLoader = ({ className = "" }) => {
  return (
    <div className={classNames("custom-page-loader-component", className)}>
      <CircularProgress />
    </div>
  );
};

export default CustomPageLoader;
